


export default {
  
  pos_manual_transactions: {
    name: '💳 Manual Transactions',
    location: 'heroku',
    sql: `--EXPLAIN 
    with _terminals as (
      select distinct on (vid, unnest(terminal_id))
      vid,
      unnest(terminal_id) as  terminal_id
      from taxicaller.atl_dodb
    ), terminals as (
      SELECT array_agg(vid) as vid, terminal_id from _terminals group by terminal_id
    ),a as (
      SELECT
        m.group,
        month,	
        device_number,	
        vid,
        settlement_date,
        to_char(transaction_date, 'Dy MM/DD/YY HH:MI Pm') as transaction_date,	
        card_type_key as product,	
        cardholder_number,	
        to_char(transaction_amount, '999999d99') as amount,	
        transaction_type_key as result,	
        batch_number,	
        to_char(settled_amount, '999999d99') as settled_amount
    -- 		merchant_number,	
    -- 		lookup,	
    -- 		pot_code
      from pos.transactions t
      join pos.merchant m on (t.merchant_number = m.merchant_number)
      left join terminals on (terminal_id = device_number)
      where pot_code = 'M'
      order by t.transaction_date desc
    -- 	limit 5000
    
    )
    
    -- select * from last_transactions
    select * from a
    `
  },
  daily_taxi_trips_summary: {
    name: '📈📱Daily Taxi Trips Summary',
    location: 'heroku',
    sql: `--EXPLAIN 
    with days_series as (
      select generate_series( date_trunc('day', now() at time zone 'America/Regina') - '14 days'::interval, date_trunc('day', now() at time zone 'America/Regina'), '1 day'::interval) as ts
    ), days as (
      select ts, extract('dow' from date_trunc('day', ts)) || '_' || row_number() OVER (order by date_trunc('day', ts) desc) as dow
      from days_series
    ), last_year_counts as (
      select 
        date_trunc('day', effective_ts at time zone 'America/Regina'),
        extract('dow' from date_trunc('day', effective_ts at time zone 'America/Regina')) || '_' || row_number() OVER (order by date_trunc('day', effective_ts at time zone 'America/Regina') desc) as dow,
        count(*) as total,
        SUM(CASE WHEN data->'account'->>'src' = '1' then 1 else 0 end) dispatched,
        mean_temp,
        snow_on_grnd,
        date_trunc('day', effective_ts at time zone 'America/Regina') + '52 weeks'::interval as join_day
      from taxicaller.job 
      --the where clause doesn't need to be set to America/Regina tz FYI
      join weather.daily on (daily.date = date_trunc('day', effective_ts at time zone 'America/Regina'))
      where effective_ts >= date_trunc('day', now()) - '13 days'::interval - '52 weeks'::interval
      and effective_ts < now() - '52 weeks'::interval
      group by date_trunc('day', effective_ts at time zone 'America/Regina'), mean_temp, snow_on_grnd
    )
    select 
      to_char(ts, 'yyyy-mm-dd') as day,
      to_char(ts, 'Dy') ||
        CASE extract(dow from ts) WHEN 1 then '' WHEN 0 then '☀️' WHEN '6' then ' *♄' WHEN '5' then ' *♀' ELSE '' END as dow,
      --count(*)::text as total, 
      --min(last_year_counts.total)::text as last_year_dow_total,
      
      daily.mean_temp as temp,
      min(last_year_counts.mean_temp) as last_year_temp,
      
      
      SUM(CASE WHEN data->'account'->>'src' = '1' then 1 else 0 end)::text as dispatched,
      min(last_year_counts.dispatched)::text || ' -> ' ||
        to_char(100.0 * (SUM(CASE WHEN data->'account'->>'src' = '1' then 1 else 0 end)::float / min(last_year_counts.dispatched)::float) - 100.00, 'PLMIMI990.00') || ' %'  as last_year_dow_dispatched,
        
      min(daily_taxi_transactions.count) as "#pos",
      to_char(min(daily_taxi_transactions.amount), '999999.00') as "pos",
      
      SUM(CASE WHEN data->'account'->>'src' != '1' then 1 else 0 end)::text as street,
    
      -- '              ' as "_______________________________",
      SUM(CASE WHEN data->'account'->>'creator' = '13630' and data->'extra'->>'info' !~* 'test .*'
      then 1 else 0 END)::text as web,
      
      to_char(100.0 * (
        SUM(CASE WHEN data->'account'->>'creator' = '13630' and data->'extra'->>'info' !~* 'test .*' then 1 else 0 END)::float 
        / ( 
            SUM(CASE WHEN data->'account'->>'src' = '1' then 1 else 0 end)::float
        -- 	- SUM(CASE WHEN data->'account'->>'creator' = '13630' and data->'extra'->>'info' !~* 'test .*' then 1 else 0 END)::float 
        ) 
      ), '990.0') || ' %' as "web_%",
      
      
    -- 	'|' as "|",
      SUM(CASE WHEN COALESCE(data->'extra'->'tags'->'clients'->0->>'_email', data->'extra'->'tags'->'clients'->0->>'email') != '' and data->'extra'->>'info' !~* 'test .*' then 1 else 0 END)::text as emails
      
      /*to_char(15.00/(
        (SUM(CASE WHEN data->'account'->>'src' = '1' then 1 else 0 end) - SUM(CASE WHEN data->'account'->>'creator' = '13630' and data->'extra'->>'info' !~* 'test .*' then 1 else 0 END))
       /24), '90.00') as cpt*/
      --to_char(100.0 * (SUM(CASE WHEN data->'extra'->'tags'->'clients'->0->>'email' != '' and data->'extra'->>'info' !~* 'test .*' then 1 else 0 END)::float / SUM(CASE WHEN data->'account'->>'creator' = '13630' and data->'extra'->>'info' !~* 'test .*'
      --then 1 else 0 END)::float), '990') || ' %' as "email_%"
    
    
    from taxicaller.job 
      JOIN days ON (date_trunc('day', effective_ts at time zone 'America/Regina') = days.ts)
    -- 	LEFT JOIN last_year_counts ON (days.dow = last_year_counts.dow)
      LEFT JOIN last_year_counts ON (date_trunc('day', effective_ts at time zone 'America/Regina') = last_year_counts.join_day)
      JOIN weather.daily ON (daily.date = date_trunc('day',days.ts))
      LEFT JOIN pos.daily_taxi_transactions ON (daily_taxi_transactions.date =  date_trunc('day',days.ts))
    where date_trunc('day', effective_ts at time zone 'America/Regina') > date_trunc('day', now()) - '14 days'::interval
    group by ts, daily.mean_temp
    order by ts desc`
  }
}